import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';

export const StatusIcons = {
  Approve: lazyImportSvg(() => import('@/assets/icons/status/approve.svg')),
  ApproveLarge: lazyImportSvg(() => import('@/assets/icons/status/approve-lg.svg')),
  ApproveSmall: lazyImportSvg(() => import('@/assets/icons/status/approve-sm.svg')),
  Loading: lazyImportSvg(() => import('@/assets/icons/status/loading.svg')),
  PendingLarge: lazyImportSvg(() => import('@/assets/icons/status/pending-lg.svg')),
  PendingSmall: lazyImportSvg(() => import('@/assets/icons/status/pending-sm.svg')),
  Reject: lazyImportSvg(() => import('@/assets/icons/status/reject.svg')),
};

export default StatusIcons;
